export default __webpack_public_path__ + "static/media/Screenshot_B19.c26fc033.jpg";